<template>
    <div class="content">
        <!--搜索-->
        <div class="searchBox">
                <div class="left">欢迎你的到来，今天是{{year}}年{{month}}月{{day}}日 {{week}}</div>
                <div class="right"><el-input v-model="searchValue" placeholder="请输入内容"></el-input><p @click="goPolicy('搜索本站')" class="menuBox">搜索本站</p></div>
        </div>

        <!--页面内容-->
        <div class="top newContent">
            <div class="left">
                <el-carousel trigger="click">
                    <el-carousel-item v-for="(item,index)  in imgUrlBox" :key="index">
                        <img :src="item" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="middle">
                <div class="conTitle"><p>新闻动态</p><p @click="goPolicy('新闻动态')"></p></div>
                <div class="publicCon  middleNewCon">
                    <div v-if="dataList1 && dataList1.length>0" class="firstBox" @click="goPolicyDetails(dataList1.length>0 &&dataList1[0])">
                        <div class="title" v-html="dataList1 && dataList1[0].title"></div>
                        <div class="firstCon" v-html="dataList1[0].subTitle"></div>
                    </div>

                    <div class="endBox">
                        <p @click="goPolicyDetails(item,'新闻动态')"  v-for="(item,index) in dataList1" :key="index" v-if="index < 4">
                            <span>[{{item.createDate.slice(0,11)}}] </span>
                          <span v-html="item.title"></span>
                        </p>
                    </div>
                </div>

            </div>
            <div class="right">
                <div class="lis" @click="goLongin(1)"></div>
                <div class="lis" @click="goLongin(2)"></div>
                <div class="lis" @click="goLongin(3)"></div>
                <div class="bottom">
                    <p @click="goLongin(4)"><img src="../../../public/image/home/jigou.png" alt="">机构注册</p>
                    <p @click="goLongin(5)"><img src="../../../public/image/home/jigoucx.png" alt="">注册状态查询</p>
                </div>
            </div>
        </div>

        <div class="middleBox">
            <div class="left">
                <div class="conTitle"><p>政策法规</p><p @click="goPolicy('政策法规')"></p></div>
                <div class="publicCon  leftNewCon">
                    <p  @click="goPolicyDetails(item,'政策法规')" v-for="(item,index) in dataList2" :key="index" v-if="index < 5">
                        <span>[{{item.createDate.slice(5,11)}}] </span>
                      <span v-html="item.title"></span>
                    </p>
                </div>
            </div>
            <div class="middle">
                <div class="conTitle"><p><span style="color: #2e71c9">维修使用</span>/验收公示</p><p @click="goPolicy('服务指南')"></p></div>
                <div class="publicCon  middleNewCon">
                    <p @click="goPolicyDetails(item,'服务指南')"  v-for="(item,index) in dataList3" :key="index" v-if="index < 5">
                        <span v-html="item.title"></span>
                        <span>[{{item.createDate.slice(5,11)}}] </span>
                    </p>
                </div>
            </div>
            <div class="right">
                <div class="conTitle"><p>通知公告</p><p @click="goPolicy('通知公告')"></p></div>
                <div class="publicCon  rightNewCon">
                    <p @click="goPolicyDetails(item,'通知公告')" v-for="(item,index) in dataList4" :key="index" v-if="index < 5">
                        <span>[{{item.createDate.slice(5,11)}}] </span>
                      <span v-html="item.title"></span>
                    </p>
                </div>
            </div>

        </div>

        <div class="bottomBox">
            <div class="left  conText">
                <div class="conTitle"><p>下载中心</p><p @click="goPolicy('下载中心')"></p></div>
                <div class="leftNewCon">
                    <p  @click="goPolicyDetails(item,'下载中心')" v-for="(item,index) in dataList5" :key="index" v-if="index < 5">
                        <span></span>
                        <span v-html="item.title"></span>
                        <span><a style="color: #3A83F4;text-decoration-line:none" :href="url+'/api-file/files/downFileByfileId?client_id=webApp_hx&fileid='+item.files">下载</a></span>
                    </p>
                </div>
            </div>
            <div class="middle01 conText">
                <div class="conTitle"><p>服务指南</p><p @click="goPolicy('服务指南')"></p></div>
                <div class="publicCon  middleNewCon">
                    <p @click="goPolicyDetails(item,'服务指南')" v-for="(item,index) in dataList6" :key="index" v-if="index < 5">
                        <span>[{{item.createDate.slice(5,11)}}] </span>
                      <span v-html="item.title"></span>
                    </p>
                </div>
            </div>
            <div class="middle02 conText">
                <div class="conTitle"><p>维修指南</p><p @click="goPolicy('维修指南')"></p></div>
                <div class="publicCon  middleNewCon">
                    <p  @click="goPolicyDetails(item,'维修指南')" v-for="(item,index) in dataList7" :key="index" v-if="index < 5">
                        <span>[{{item.createDate.slice(5,11)}}] </span>
                      <span v-html="item.title"></span>
                    </p>
                </div>
            </div>
            <!--<div class="right">-->
                <!--<div class="conTitle"><p>业主参与</p><p @click="goPolicy('业主参与')"></p></div>-->
                <!--<div class="rightNewCon">-->
                   <!--<div class="con_left">-->
                       <!--<p>业主公司满意度</p>-->
                       <!--<p>业主公司满意度</p>-->
                   <!--</div>-->
                    <!--<div class="con_right">-->
                        <!--<p><span></span><span>兰州富润物业有限公司</span></p>-->
                        <!--<p><span></span><span>兰州富润物业有限公司</span></p>-->
                        <!--<p><span></span><span>兰州富润物业有限公司</span></p>-->
                        <!--<p><span></span><span>兰州富润物业有限公司</span></p>-->
                        <!--<p><span></span><span>兰州富润物业有限公司</span></p>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->

        </div>

    </div>
</template>

<script>
     import urljson from "../../static/json/url.json";
    export default {
        name: "homeContent",
        data(){
            return{
                searchValue:'',
                dataList1:[],
                dataList2:[],
                dataList3:[],
                dataList4:[],
                dataList5:[],
                dataList6:[],
                dataList7:[],
                dataList8:[],
                url: this.$Config.base_server,
                year:'',
                 month:'',
                day:'',
                week:'',
                client_id:'',
                imgUrlBox:[
                    require('../../static/image/banner0.png'),
                    require('../../static/image/banner1.jpeg'),
                    require('../../static/image/banner2.jpeg'),
                    require('../../static/image/banner3.jpeg'),
                ]
            }

        },

        created(){
			    const that = this;
				localStorage.removeItem("client_id");
                localStorage.removeItem("adminurl");
			    if (localStorage.getItem("token") == "" ||  localStorage.getItem("token") == null) {
					let urldata=urljson;
					var url = window.location.href;
					//循环
					urldata.forEach((value,key)=>{
						if (url.indexOf(value.key)>=0){
							localStorage.setItem("client_id",value.client_id);
                            localStorage.setItem("adminurl",value.adminurl);
							this.client_id=localStorage.getItem("client_id");
							return false;
						}
					});
				}else{
                    if (JSON.parse(localStorage.getItem("user")).type == "0") {
                        //物业
                        that.$router.push({ name: "proVillage" });
                    } else if (JSON.parse(localStorage.getItem("user")).type == "3") {
                        that.$router.push({
                            name: "ownerVillage",
                            params: { userId: 123 }
                        });
                    } else if (JSON.parse(localStorage.getItem("user")).type == "2") {
                        //业主委员会
                        that.$router.push({
                            name: "hoaVillage",
                            params: { userId: 123 }
                        });
                    } else if (JSON.parse(localStorage.getItem("user")).type == "1") {
                        //开发商
                        that.$router.push({ name: "table", params: { userId: 123 } });
                    }

                }
            this.getDataList('新闻动态');
            this.getDataList('政策法规');
            this.getDataList('维修使用');
            this.getDataList('通知公告');
            this.getDataList('下载中心');
            this.getDataList('服务指南');
            this.getDataList('维修指南');
            this.getDataList('业主参与');
          let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
          let now=new Date()
          this.year = 1900+now.getYear()
          this.month = 1+now.getMonth()
          this.day = now.getDate()
          let wk = now.getDay()
          this.week = weeks[wk]
        },

        methods:{
            goPolicyDetails(item,name){
              this.$emit('tablePage',name);
              if (item.type=='下载中心'){

              }else {
                this.$router.push({path:'/policyDetails',query: {id:item.id}})
              }
            },

          goPolicy(val){
             this.$emit('tablePage',val);
            let q = {title:val,status: '0'}
            if (val =='搜索本站'){
              if (this.searchValue && this.searchValue.length>0){
                q.searchValue = this.searchValue
              }else {
               // this.$message.error('请输入查询内容');
                return false
              }
            }else {
              let q = {title:val,status: '0'}
            }

            this.$router.push({
              path:'/policy',
              query:q})
          },


            // 登录
            goLongin(id){
                if(id == 1){
                    const  adminurl=localStorage.getItem("adminurl");
                    localStorage.removeItem("token");
                    localStorage.removeItem("client_id");
                    window.open(adminurl, "_blank");
                }else {
                    this.$router.push({path:'/index?id=' + id})
                }
            },
            // 请求列表数据
            getDataList(val){
                let _this = this;
                $.ajax({
                    url: _this.url + "/api-base/oanotify/list/",
                    type: "GET",
                    data:{client_id:this.client_id,type:val,status:0},
                    dataType: "json", //返回数据格式为json
                    success: (res)=> {
                       if (res.data && res.data.length > 0){
                         switch (val){
                           case '新闻动态':
                             _this.dataList1 = res.data;
                             break;
                           case '政策法规':
                             _this.dataList2 = res.data;
                             break;
                           case '维修使用':
                             _this.dataList3 = res.data;
                             break;
                           case '通知公告':
                             _this.dataList4 = res.data;
                             break;
                           case '下载中心':
                             _this.dataList5 = res.data;
                             break;
                           case '服务指南':
                             _this.dataList6 = res.data;
                             break;
                           case '维修指南':
                             _this.dataList7 = res.data;
                             break;
                           case '业主参与':
                             _this.dataList8 = res.data;
                             break;
                         }
                       }
                    },
                    error: (err)=> {

                    }
                });
            }

        }
    }
</script>

<style scoped lang="scss">
    .content{
        width: 100%;
        .searchBox{
            width: 100%;
            height: 60px;
            border-bottom: 2px solid #2e71c9;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left{
                font-size: 14px;
            }
            .right{
                height: 100%;
                display: flex;
                align-items: center;
                .menuBox{
                    width: 120px;
                    height: 40px;
                    background: #2e71c9;
                    font-size: 14px;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                }
            }
        }
        .conTitle{
            width: 100%;
            height: 36px;
            background: #f7f7f7;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px;
            box-sizing: border-box;
            border-top: 2px solid #2e71c9;
            p:nth-of-type(1){
                font-size: 14px;
                font-weight: 700;
            }
            p:nth-of-type(2){
                width: 35px;
                height: 22px;
                background: url("../../../public/image/home/more.png") no-repeat center;
                background-size: 100% 100%;
                cursor: pointer;
            }
        }

        .publicCon{
            width: 100%;
            padding: 5px;
            box-sizing: border-box;
            margin-bottom: 15px;
            p{
                width: 100%;
                font-size: 14px;
                display: flex;
                align-items: center;
                margin-top: 15px;
                cursor: pointer;
                span:nth-of-type(1){
                    width: 60px;
                    display: inline-block;

                }
                span:nth-of-type(2){
                    width: calc(100% - 60px);
                    display: inline-block;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;

                }

            }
        }


        .newContent{
            width: 100%;
            height: 275px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 0 10px 0;
            .left{
                width: 410px;
                height: 100%;
                background: url("/image/home/xinwen.png") no-repeat center;
                background-size: 100% 100%;
                img{
                    width: 100%;
                    height: 81%;
                }
            }

            .middle{
                width: 330px;
                height: 100%;
                /*background: yellow;*/
                .conTitle{
                    border-top: none;
                    p:nth-of-type(1){
                        border-left: 5px solid #3A83F4;
                        text-indent: 10px;
                    }
                }
                .middleNewCon{
                    width: 100%;
                    margin-bottom: 0;
                    .firstBox{
                        width: 100%;
                        .title{
                            width: 100%;
                            font-size: 16px;
                            color: #e14e2a;
                            font-weight: 700;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            display: inline-block;
                            cursor: pointer;
                        }
                        .firstCon{
                            font-size: 14px;
                            color: #999999;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 3;
                            overflow: hidden;
                        }
                    }
                    .endBox{
                        width: 100%;
                        p{
                            margin-top: 10px;
                            span:nth-of-type(1){
                                width: 100px;
                                display: inline-block;

                            }
                            span:nth-of-type(2){
                                width: calc(100% - 100px);
                            }
                        }

                    }

                }


            }

            .right{
                width: 240px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .lis{
                    width: 100%;
                    height: 72px;
                    background-size: 100% 100%;
                    background: center;
                    cursor: pointer;
                }
                .lis:nth-of-type(1){
                    background: url("../../../public/image/home/fangguanju.png") no-repeat center;

                }
                .lis:nth-of-type(2){
                    background: url("../../../public/image/home/wuye.png") no-repeat center;
                }
                .lis:nth-of-type(3){
                    height: 40px;
                    background: url("../../../public/image/home/yezhu.png") no-repeat center;
                }

                .bottom{
                    height: 40px;
                    width: 240px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    p{
                        width: 115px;
                        height: 100%;
                        border:1px solid #2e71c9;
                        color: #2e71c9;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        img{
                            margin-right: 5px;
                        }
                    }
                }
            }
        }

        .middleBox{
            width: 100%;
            display: flex;
            /*align-items: center;*/
            justify-content: space-between;
            .left{
                width: 243px;
            }
            .middle{
                width: 496px;
                .middleNewCon{
                    width: 100%;
                    padding: 5px;
                    box-sizing: border-box;
                    margin-bottom: 15px;
                    p{
                        width: 100%;
                        font-size: 14px;
                        display: flex;
                        align-items: center;
                        margin-top: 15px;
                        cursor: pointer;
                        justify-content: space-between;
                        span:nth-of-type(2){
                            width: 120px;
                            display: inline-block;
                            text-align: center;

                        }
                        span:nth-of-type(1){
                            width: calc(100% - 120px);
                            display: inline-block;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                }
            }

            .right{
                width: 240px;
            }
        }

        .bottomBox{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left{
                /*width: 243px;*/
                .leftNewCon{
                    width: 100%;
                    padding: 5px;
                    box-sizing: border-box;
                    margin-bottom: 15px;
                    p{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 15px;
                        font-size: 14px;
                        span{
                            display: inline-block;
                        }
                        span:nth-of-type(1){
                            width: 30px;
                            height: 18px;
                            background: url("../../../public/image/home/Excel.png") no-repeat center;

                        }
                        span:nth-of-type(2){
                            font-size: 14px;
                            width: calc(100% - 70px);
                            display: inline-block;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            cursor: pointer;
                        }
                        span:nth-of-type(3){
                            width: 40px;
                            color: #2e71c9;
                            text-align: right;
                            cursor: pointer;
                        }
                    }
                }
            }
            /*.middle01{*/
                /*width: 243px;*/
            /*}*/
            /*.middle02{*/
                /*width: 243px;*/
            /*}*/
             .conText{
                 width: calc(100%/3 - 10px);
             }
            /*.right{*/
                /*width: 240px;*/
                /*.rightNewCon{*/
                    /*width: 100%;*/
                    /*display: flex;*/
                    /*justify-content: space-between;*/
                    /*align-items: center;*/
                    /*margin-bottom: 25px;*/
                    /*.con_left{*/
                        /*display: flex;*/
                        /*flex-direction: column;*/
                        /*justify-content: space-between;*/
                        /*p{*/
                            /*width: 66px;*/
                            /*height: 60px;*/
                            /*display: flex;*/
                            /*align-items: center;*/
                            /*justify-content: center;*/
                            /*border: 1px solid #e2e2e2;*/
                            /*font-size: 12px;*/
                            /*text-align: center;*/
                            /*padding: 8px;*/
                            /*cursor: pointer;*/
                        /*}*/
                        /*p:nth-of-type(1){*/
                            /*background: #2e71c9;*/
                            /*color: #fff;*/
                            /*margin-bottom: 20px;*/
                        /*}*/
                    /*}*/
                    /*.con_right{*/
                        /*margin-left: 25px;*/
                        /*width: calc(100% - 85px);*/
                        /*p{*/
                            /*display: flex;*/
                            /*align-items: center;*/
                            /*justify-content: space-between;*/
                            /*margin-top: 15px;*/
                            /*font-size: 14px;*/
                            /*cursor: pointer;*/
                            /*span{*/
                                /*display: inline-block;*/
                            /*}*/
                            /*span:nth-of-type(1){*/
                                /*width: 18px;*/
                                /*height: 18px;*/
                                /*background: url("../../../public/image/home/3.png") no-repeat center;*/

                            /*}*/
                            /*span:nth-of-type(2){*/
                                /*font-size: 14px;*/
                                /*width: calc(100% - 33px);*/
                                /*display: inline-block;*/
                                /*overflow: hidden;*/
                                /*white-space: nowrap;*/
                                /*text-overflow: ellipsis;*/
                                /*cursor: pointer;*/
                            /*}*/
                        /*}*/
                    /*}*/
                /*}*/
            /*}*/
        }
    }
</style>
